<template>
    <div class="gallery__card">
        <galleryImageComponent img-class="gallery__card__img" :img="img" :alt="alt" :gallery-size="gallerySize" />
        <p class="gallery__card__caption">
            {{ caption }}
        </p>
    </div>
</template>

<script>
import galleryImageComponent from './gallery-image-component.vue';

export default {
    components: {
        galleryImageComponent
    },
    props: {
        img: {
            type: Object,
            default: () => ({ src: 'default_image_path.png', alt: 'Default Alt Text' })
        },
        alt: {
            type: String,
            default: 'Default Alt Text'
        },
        caption: {
            type: String,
            default: ''
        },
        gallerySize: {
            type: Number,
            default: 0
        }
    },
    setup() {
        return {};
    },
};
</script>

